// Мобильное меню шапки (вариант menu: 'js'). Разметку даёт headerHtml; для варианта 'details' скрипт не нужен.
// Interface: initSiteHeader() — повесить обработчики на #burger и #mnav; можно звать один раз.

export function initSiteHeader() {
  const burger = document.getElementById('burger');
  const mnav = document.getElementById('mnav');
  if (!burger || !mnav) return;
  const set = (open) => {
    mnav.hidden = !open;
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Закрыть меню' : 'Открыть меню');
  };
  burger.addEventListener('click', () => set(mnav.hidden));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !mnav.hidden) { set(false); burger.focus(); }
  });
  window.matchMedia('(min-width: 781px)').addEventListener('change', (e) => { if (e.matches) set(false); });
  mnav.addEventListener('click', (e) => { if (e.target.closest('a')) set(false); });
}
